import React from 'react';
import { Provider } from 'react-redux';

function withProvider(WrappedComponent, store) {
    function WithProvider(props) {
        return (
            <Provider store={store}>
                <WrappedComponent {...props} />
            </Provider>
        );
    }

    const wrappedComponentName =
        WrappedComponent.displayName || WrappedComponent.name || 'Component';

    WithProvider.displayName = `${wrappedComponentName}WithProvider`;

    return WithProvider;
}

export default withProvider;
